export default "__VITE_ASSET__C1me_Pn7__"